import { DefaultTheme } from 'styled-components';

const light: DefaultTheme = {
  colorScheme: 'light',
  colors: {
    // Backgrounds
    primary_background: '#F6FAFD',
    secondary_background: '#FBFCFD',
    tertiary_background: '#06283B',

    // Elements
    primary_element: '#06283B',
    secondary_element: '#365262',
    tertiary_element: '#7E919C',

    // Basic colors
    black: '#000000',
    white: '#FFFFFF',

    // Special colors
    black_blue: '#06283B',
  },
};

export const themes = {
  light,
};
